import React from "react";
import { Col, Row, Spin } from "antd";
import { useLocation } from "react-router-dom";

import ProfileView from "./ProfileView/ProfileView";
import ConversationView from "./ConversationView/ConversationView";
import { useConversations } from "./api/conversations";
import { getToken } from "services/token-service/token.service";

import "./AgentView.scss";
import { useSocket, wsEvents } from "../../hooks/useSocket";

const AgentView = (props) => {
  const token = getToken();
  const getUrl = window.location.pathname;
  const urlData = getUrl.split("/").pop();
  const location = useLocation();
  const prevPath = location.state?.prevPath ? location.state?.prevPath : "";
  useSocket({
    type: wsEvents.AGENT_ONLINE,
    callBack: (payload) => {
      return payload;
    },
  });
  const {
    data: conversationData,
    isFetching: loadingConversation,
    refetch,
  } = useConversations(urlData, token);
  return (
    <div className="AgentView">
      {loadingConversation ? (
        <div className="LoaderContainer">
          <Spin tip="Loading conversation" />
        </div>
      ) : (
        <Row>
          <Col md={5} lg={5}>
            <ProfileView type="user" data={conversationData?.data?.data} />
          </Col>
          <Col md={14} lg={14}>
            <ConversationView
              convData={conversationData?.data?.data}
              token={token}
              refetchConversation={refetch}
              prevPath={prevPath}
            />
          </Col>
          <Col md={5} lg={5}>
            <ProfileView type="profile" data={conversationData?.data?.data} />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default AgentView;
